import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "../../environments/environment";
@Injectable({
  providedIn: 'root'
})
export class LoginService {
  url:string = environment.url;
  constructor(private http: HttpClient) {

  }

  getOTP(data){
      return this.http.post(`${this.url}login/get-otp/`, data)
  }
  verifyOTP(data){
      return this.http.post(`${this.url}login/verify-otp/`, data)

  }
}
